import client from "../client/client";

class AiDetectionsService {
	getFieldData({ projectId, fieldUuid }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/fields/${fieldUuid}/data`, {
			config: { cancelToken },
		});
	}

	updateFieldStatus({ projectId, fieldUuid }, isAccepted, cancelToken) {
		return client.patch(`/ai-detection/projects/${projectId}/fields/${fieldUuid}/status`, {
			params: { isAccepted },
			config: { cancelToken },
		});
	}

	likeValueSource({ projectId, fieldUuid, informationId }, isVerified, cancelToken) {
		return client.patch(
			`/ai-detection/projects/${projectId}/fields/${fieldUuid}/information/${informationId}/status`,
			{
				params: { isVerified },
				config: { cancelToken },
			}
		);
	}

	getPageList({ projectId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/pages`, {
			config: { cancelToken },
		});
	}

	getDetectionPageTemplate({ projectId, pageId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/pages/${pageId}`, {
			config: { cancelToken },
		});
	}

	getFieldsValues({ projectId, pageId }, payload, cancelToken) {
		return client.post(`/ai-detection/projects/${projectId}/pages/${pageId}/values`, {
			payload,
			config: { cancelToken },
		});
	}

	exportPage({ projectId, pageId }, { templateId }, cancelToken) {
		return client.download(`/ai-detection/projects/${projectId}/pages/${pageId}/export`, {
			params: { templateId },
			config: { cancelToken },
		});
	}

	executeAgentOnPage({ projectId, pageId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/pages/${pageId}/agent`, {
			config: { cancelToken },
		});
	}

	getIsAiDetectionsLaunchActive({ projectId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/criteria/launch`, {
			config: { cancelToken },
		});
	}

	addNewValueSource({ projectId, fieldUuid }, payload, cancelToken) {
		return client.put(`/ai-detection/projects/${projectId}/fields/${fieldUuid}`, {
			payload,
			config: { cancelToken },
		});
	}

	updateCriteriaValue({ projectId, fieldUuid }, payload, cancelToken) {
		return client.patch(`/ai-detection/projects/${projectId}/fields/${fieldUuid}/value`, {
			payload,
			config: { cancelToken },
		});
	}

	getCheckDetection({ projectId, pageId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/pages/${pageId}/has-values`, {
			config: { cancelToken },
		});
	}

	getProgressSnapshot({ projectId, pageId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/pages/${pageId}/agent/progress`, {
			config: { cancelToken },
		});
	}

	getInnerFields({ projectId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/fields/inner`, {
			config: { cancelToken },
		});
	}

	updateInnerField({ projectId, fieldUuid }, payload, cancelToken) {
		return client.patch(`/ai-detection/projects/${projectId}/fields/${fieldUuid}/innerfields`, {
			payload,
			config: { cancelToken },
		});
	}

	getInnerFieldPossibleValues({ projectId, fieldUuid }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/fields/${fieldUuid}/possible-value`, {
			config: { cancelToken },
		});
	}

	getChartCounters({ projectId, pageId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/pages/${pageId}/chart`, {
			config: { cancelToken },
		});
	}

	getTemplates({ projectId }, cancelToken) {
		return client.get(`/ai-detection/projects/${projectId}/templates`, {
			config: { cancelToken },
		});
	}
}

export default new AiDetectionsService();
